import { useMutation } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { canUseWizardTestTools } from '@shared';
import { selectSession } from '@/model';
import { consumerApi } from '../api/consumer-api';
import { consumerEntryPath } from '../lib/paths';
import { usePolicyReviewDraftActions } from '../stores/policy-review-draft-store';

/**
 * Lets a wizard wipe the client's guided flow to test it from the start. A full reload follows
 * so the plan, care plan and payment status all come back fresh from the server.
 */
export function useConsumerFlowReset(clientId: string) {
  const canReset = canUseWizardTestTools(useSelector(selectSession));
  const { reset: resetReviewDraft } = usePolicyReviewDraftActions();
  const reset = useMutation({
    mutationFn: () => consumerApi.resetFlowForWizard(clientId),
    onSuccess: () => {
      resetReviewDraft();
      window.location.assign(consumerEntryPath(clientId));
    },
  });

  return { canReset, resetFlow: reset.mutate, isResetting: reset.isPending, isError: reset.isError };
}
